module.exports = __webpack_public_path__ + "media/images/user-6d808fe59e84eac74ba39dea8d2f6ab6.svg";